import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ImageIcon({ className, fill, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <g fill={fill ?? IconColors.Red} fillRule="evenodd">
        <path d="M21.625 20.938c0 .759-.616 1.375-1.375 1.375H3.75c-.76 0-1.375-.616-1.375-1.375V3.063c0-.76.616-1.376 1.375-1.376h13.791c.36 0 .704.14.96.391l2.709 2.643c.265.259.415.614.415.984v15.233zM6.375 6.75h-.003c-.62.002-1.123.506-1.122 1.127.001.62.505 1.124 1.126 1.123.62 0 1.124-.504 1.124-1.125S6.996 6.75 6.375 6.75zm4.366 5.669l-.613-.49c-.328-.262-.752-.375-1.167-.31-.415.065-.784.3-1.017.65l-2.546 3.815c-.332.498.025 1.166.624 1.166H18c.598 0 .956-.666.625-1.164l-3.87-5.836c-.278-.415-.74-.664-1.235-.668-.496-.004-.962.237-1.244.645l-1.535 2.192zm5.862 3.331H7.424l1.768-2.649 1.237.989c.338.27.834.199 1.082-.156l1.997-2.852 3.095 4.668z" />
      </g>
    </SimpleIcon>
  );
}
